import { createApi } from "@reduxjs/toolkit/query/react";
import { GenericResponse, IUser } from "@/redux/models";
import customFetchBase from "./customFetchBase";
import { ContactInput } from "@/pages/principal/ContactPage";


export const userApi = createApi({
  reducerPath: "userApi",
  baseQuery: customFetchBase,
  tagTypes: ["User"],
  endpoints: (builder) => ({
    getMe: builder.query<IUser, null>({
      query() {
        return {
          url: "user/me",
        };
      },
    }),
    getAllUsersPaginado: builder.query<GenericResponse, { desde: number, hasta: number }>({
      query({ desde, hasta }) {
        return {
          url: "user/getAll",
          params: {
            desde,
            hasta
          }
        };
      },
      providesTags: ["User"],
    }),
    getAllUsers: builder.query<GenericResponse, { companyId?: number }>({
      query({ companyId }) {
        return {
          url: "user/getAllUsers",
          params: {
            companyId,
          },
        };
      },
    }),
    updateUserAsAdmin: builder.mutation<GenericResponse, IUser>({
      query(user) {
        return {
          url: `user/updateUserAdm?id=${user.id}`,
          method: "PUT",
          body: user,
        };
      },
      invalidatesTags: ["User"],
    }),
    updateUser: builder.mutation<GenericResponse, IUser>({
      query(user) {
        return {
          url: `user/updateUser?id=${user.id}`,
          method: "PUT",
          body: user,
        };
      },
      invalidatesTags: ["User"],
    }),
    actualizarUsuario: builder.mutation<GenericResponse, IUser>({
      query(user) {
        return {
          url: `user`,
          method: "PUT",
          body: {
            ...user,
            companyId: user.company?.id
          }
        };
      },
      invalidatesTags: ["User"],
    }),
    updateFoto: builder.mutation<GenericResponse, FormData>({
      query(formData) {
        return {
          url: `user/updatePfp`,
          method: "PUT",
          body: formData,
        };
      },
      invalidatesTags: ["User"],
    }),
    eliminarUser: builder.mutation<any, { id: number, code: string }>({
      query(args) {
        return {
          url: `user`,
          method: "DELETE",
          params: args
        };
      },
      invalidatesTags: ["User"],
    }),
    enviarConsulta: builder.mutation<GenericResponse, ContactInput>({
      query(contactInput) {
        return {
          url: `email/enviarConsulta`,
          method: "POST",
          params: contactInput,
        };
      },
    }),
  }),
});


export const { useGetMeQuery, useGetAllUsersPaginadoQuery,
  useGetAllUsersQuery, useUpdateUserAsAdminMutation,
  useUpdateUserMutation,
  useActualizarUsuarioMutation,
  useUpdateFotoMutation,
  useEliminarUserMutation, useEnviarConsultaMutation } = userApi;